import { IconProps } from '../icon-props-interface';
import '../icons.scss';

export const IconPlus: React.FC<IconProps> = ({ color = 'var(--color-accent-1)' }): JSX.Element => (
    <div className="icon-block">
        <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M8.5 15C12.366 15 15.5 11.866 15.5 8C15.5 4.13401 12.366 1 8.5 1C4.63401 1 1.5 4.13401 1.5 8C1.5 11.866 4.63401 15 8.5 15ZM8.5 16C12.9183 16 16.5 12.4183 16.5 8C16.5 3.58172 12.9183 0 8.5 0C4.08172 0 0.5 3.58172 0.5 8C0.5 12.4183 4.08172 16 8.5 16Z" fill={color}/>
            <path d="M8.5 5V11M11.5 8L5.5 8" stroke={color} strokeWidth="1.1" strokeLinecap="round"/>
        </svg>
    </div>
);

export default IconPlus;
